export const RESULTS_PER_PAGE_OPTIONS = [
    { pSizeText: '#5', pSize: 5 },
    { pSizeText: '#10', pSize: 10 },
    { pSizeText: '#15', pSize: 15 },
    { pSizeText: '#20', pSize: 20 },
    { pSizeText: '#50', pSize: 50 },
    { pSizeText: '#100', pSize: 100 },
    { pSizeText: '#150', pSize: 150 },
    { pSizeText: '#300', pSize: 300 },
    { pSizeText: '#500', pSize: 500 },
];



// WEBPACK FOOTER //
// ./src/utils/resultsPerPageOptions.js